<template>
  <div class="date-select">
    <template v-if="dateType === '秒' || dateType === '分'">
      <el-date-picker
        v-model="getGroupDateModel.model"
        type="date"
        :value-format="dateFormat"
        :format="dateFormat"
        placeholder="请选择日期"
        @input="changeDate($event)"
      >
      </el-date-picker>
      <el-time-picker
        v-model="getGroupTimeModel.model"
        :value-format="dateTypeFormat"
        :format="dateTypeFormat"
        placeholder="请选择时间"
        @input="changeTime($event)"
      >
      </el-time-picker>
    </template>
    <template v-else>
      <!-- 日 -->
      <el-date-picker
        v-model="getDateModel.model"
        type="date"
        :value-format="dateFormat"
        :format="dateFormat"
        placeholder="请选择日期"
        @input="dateAnswerChange($event)"
      >
      </el-date-picker>
    </template>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import { saveArr } from '../public/index.js'

export default {
  name: 'DateSelect',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dateFormat: 'yyyy-MM-dd'
    }
  },
  computed: {
    dateTypeFormat() {
      return this.dateType === '分' ? 'HH:mm' : 'HH:mm:ss'
    },
    dateType() {
      const fill = this.rowData.questionDetails.issue.fillContext
      return (fill && fill[0].dateType) || ''
    },
    getGroupDateModel() {
      const items = this.rowData.items
      if (Array.isArray(items) && items.length === 0) {
        items.push(Object.assign({}, itemInitOptions))
      }
      return { model: items[0].value }
    },
    getGroupTimeModel() {
      const items = this.rowData.items
      if (Array.isArray(items) && items.length === 0) {
        items.push(Object.assign({}, itemInitOptions))
      }
      return { model: items[0].value }
    },
    getDateModel() {
      const items = this.rowData.items
      if (Array.isArray(items) && items.length === 0) {
        items.push(Object.assign({}, itemInitOptions))
      }
      return { model: items[0].value }
    }
  },
  methods: {
    // 只更新 天数 部分时间戳
    changeDate(dateVal) {
      const rowItem = this.rowData.items
      if (dateVal) {
        // 更新日期部分
        if (rowItem && rowItem[0] && rowItem[0].value) {
          // 注意：匹配多个空格
          let [y = '', m = ''] = rowItem[0].value.split(/\s+/)
          const len = m.split(':').length
          if (this.dateType === '分') {
            if (len === 2) {
              // 原数据是 分
              rowItem[0].value = dateVal + (m && ' ' + m)
            } else {
              rowItem[0].value = dateVal + ' 00:00'
            }
          } else if (this.dateType === '秒') {
            if (len === 3) {
              // 原数据是 秒
              rowItem[0].value = dateVal + (m && ' ' + m)
            } else {
              rowItem[0].value = dateVal + ' 00:00:00'
            }
          }
        } else {
          rowItem[0].value = dateVal + (this.dateType === '分' ? ' 00:00' : ' 00:00:00')
        }
        // 清空 todo 暂不处理
      } else {
        rowItem[0].value = ''
      }
      this.saveArr()
    },
    // 只更新 分钟/秒钟 部分时间戳
    changeTime(timeVal) {
      const rowItem = this.rowData.items
      if (timeVal) {
        // 更新时间部分
        // 注意：匹配多个空格
        let [y = '', m = ''] = rowItem[0].value.split(/\s+/)
        if (y) {
          rowItem[0].value = y + ' ' + timeVal
        } else {
          const d = new Date()
          const y = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
          rowItem[0].value = y + ' ' + timeVal
        }
        // 清空 todo 暂不处理
      } else {
        rowItem[0].value = ''
      }
      this.saveArr()
    },
    // 日期类型的题 更新
    dateAnswerChange(val) {
      this.rowData.items[0].value = val
      this.saveArr()
    },
    // saveArr() {
    //   const existIdx = this.updateArr.findIndex((item) => {
    //     return item.questonId === this.rowData.questonId
    //   })
    //   if(existIdx === -1) { //添加
    //     this.updateArr.push(this.rowData)
    //   }
    // },
    saveArr
  }
}
</script>
